import React, { ReactNode } from "react";

import GenericTable, { props } from '../Models/GenericTable'

interface DataTableProps {
    entity: { id: string; } & Record<string, unknown>;
    status?: string;
    showBg?: props['showBg'];
    onStatusSelect?: (...params: unknown[]) => unknown;
    data?: unknown;
    columns: props['columns'];
    actions?: props['actions'];
    title?: ReactNode;
    heightOffset?: props['heightOffset'];
    parentHeight?: props['parentHeight'];
    filter?: (item: unknown) => boolean;
}

function DataTable({ entity, status, showBg, onStatusSelect, data, columns, actions, title, heightOffset, parentHeight, filter }: DataTableProps) {


    return <GenericTable
        entity={entity}
        title={title}
        showBg={showBg}
        columns={columns}
        data={data}
        actions={actions}
        status={status}
        onStatusSelect={onStatusSelect}
        style={{ height: '100%' }}
        filter={filter}
        heightOffset={heightOffset}
        parentHeight={parentHeight} />
};

export default DataTable;

